<template>
  <div class="custom-container" v-loading.fullscreen.lock="brand.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="brand-title">Edit Brand</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form label-position="left" ref="brand" label-width="120px" :model="brand.data">
          <Form :Brand="brand.data"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    Form
  },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      brand: state => state.brand.brand
    })
  },
  methods: {
    ...mapActions({
      getBrand: "brand/GetBrand",
      updateBrand: "brand/UpdateBrand"
    }),
    save() {
      this.$refs.brand.validate(valid => {
        if (valid) {
          this.updateBrand(this.brand.data);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getBrand(this.id);
  }
};
</script>

<style>
</style>
